import { useCallback } from "react"
import { Avatar, Box, Button, Typography, useTheme } from "@mui/material"
import { useNavigate } from "react-router-dom"

import { useTranslation } from "providers/i18n"
import { useHome } from "../../hooks/home/useHome"
import { useHomeMap } from "hooks/home/useHomeMap"

import { APP_STATUS, updateAppStatus } from "utils/electron"
import { getFeatureName } from "utils/feature"

import { FullScreenOverlayLayout } from "layouts/FullScreenOverlayLayout"

import { Head } from "components/Head"
import { gtmPushDataLayerSelectLanguage } from "utils/googletagmanager"

export const HomePage = () => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { venues, locales, defaultRoutePath } = useHome()

  useHomeMap(venues)

  const styleOverrides = theme.components[`HomePage`]?.styleOverrides || {}
  const {
    root,
    contentContainer,
    fullscreenLayout,
    carouselWrapper,
    welcomeContainer,
    greetingText,
    localeListContainer,
    localeButton,
    actionContainer,
    actionButton,
  } = styleOverrides

  const switchLanguage = useCallback(
    (lang) => (e) => {
      i18n.changeLanguage(lang)
      gtmPushDataLayerSelectLanguage(lang)
    },
    [i18n]
  )

  const handleClick = useCallback(() => {
    updateAppStatus(APP_STATUS.ACTIVE)
    navigate(defaultRoutePath)
  }, [navigate, defaultRoutePath])

  return (
    <>
      <Head title={t("Indoor map")} />
      <Box sx={root} className="page">
        <FullScreenOverlayLayout sx={fullscreenLayout}>
          <Box sx={contentContainer} className="contentContainer">
            <Box sx={carouselWrapper}>
              {/** To show screensaver, use KioskVApp preservedView instead */}
            </Box>
            <Box sx={welcomeContainer}>
              <Typography variant="h3" sx={greetingText}>
                {t("Welcome to", { name: t(getFeatureName(venues[0])) })}
              </Typography>
              <Box sx={localeListContainer}>
                {locales.map((locale) => (
                  <Button
                    key={locale.localeKey}
                    onClick={switchLanguage(locale.localeKey)}
                    sx={localeButton}
                  >
                    <Avatar
                      src={`https://flagcdn.com/h40/${locale.flagCode}.webp`}
                    />
                  </Button>
                ))}
              </Box>
              <Box sx={actionContainer}>
                <Button
                  sx={actionButton}
                  variant="contained"
                  onClick={handleClick}
                >
                  {t("Touch to start")}
                </Button>
              </Box>
            </Box>
          </Box>
        </FullScreenOverlayLayout>
      </Box>
    </>
  )
}
